import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  id: "update-to-approved-menu-dropdown-container",
  class: "update-to-approved-menu"
}
const _hoisted_2 = { class: "update-to-approved-menu__field" }
const _hoisted_3 = {
  id: "update-to-approved-menu-dropdown-content",
  class: "update-to-approved-menu__dropdown"
}
const _hoisted_4 = ["onClick"]

import { i18n } from '@/i18n';
import { UPDATE_TO_APPROVED_MENU_ITEMS } from '../constants';
import { nextTick, onMounted, onUnmounted, ref } from 'vue';
import { UpdateToApprovedMenuItems } from '../entities/updateToApprovedMenu';
import { UpdateToApprovedMenuService } from '../service/updateToApprovedMenuService';
import { watch } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';

const OPTION_HEIGHT = 40;


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateToApprovedMenuDropDown',
  props: {
    disabled: { type: Boolean }
  },
  emits: ["selectedItem"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const t = i18n.t;

const isOpen = ref(false);

const emit = __emit;

watch(isOpen, async (newVal) => {
  if (newVal) {
    calculateDropdownPosition();
  }
});

/**
 * ドロップダウンの表示状態を切り替えます。
 */
const toggleDropdown = () => {
  if (props.disabled) return;
  isOpen.value = !isOpen.value;
};

/**
 * オプションを選択し、親コンポーネントに選択値を通知します。
 * @param item - 選択したアイテム
 */
const selectOption = (item: UpdateToApprovedMenuItems) => {
  emit('selectedItem', item);
  isOpen.value = false;
};

/**
 * ドロップダウンを閉じます。
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!isOpen.value) return;
  const target = event.target;
  const selector = '#update-to-approved-menu-dropdown-container';
  const arrowSelector = '#update-to-approved-menu-dropdown-arrow';
  const searchSelector = '#update-to-approved-menu-dropdown-content';
  if (!(target instanceof Element)) return;
  if (target.closest(arrowSelector)) return;
  if (target.closest(selector)) return;
  if (target.closest(searchSelector)) return;

  isOpen.value = false;
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown);
});

/**
 * ドロップダウンの位置を計算し、設定します。
 */
const calculateDropdownPosition = () => {
  nextTick(() => {
    const selectBox = document.querySelector('#update-to-approved-menu-dropdown-container') as HTMLElement;
    if (selectBox) {
      const rect = selectBox.getBoundingClientRect();
      const dropdown = document.querySelector('#update-to-approved-menu-dropdown-content') as HTMLElement;
      if (dropdown) {
        dropdown.style.left = `${rect.left}px`;
        dropdown.style.top = `${rect.bottom}px`;

        // ドロップダウンの高さを計算
        const desiredHeight = OPTION_HEIGHT * UPDATE_TO_APPROVED_MENU_ITEMS.length;

        // max-heightを計算して設定
        const availableHeight = window.innerHeight - rect.bottom - 10; // 10pxは少しのマージン
        dropdown.style.maxHeight = `${Math.min(desiredHeight, availableHeight)}px`;
      }
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "update-to-approved-menu_container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDropdown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["update-to-approved-menu__selected", { 'update-to-approved-menu__selected--disabled': _ctx.disabled }]),
        onClick: toggleDropdown
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('ステータス変更')), 1),
        (isOpen.value)
          ? (_openBlock(), _createBlock(SvgLoader, {
              key: 0,
              name: "arrowUpBlue",
              class: "update-to-approved-menu__arrow"
            }))
          : (_openBlock(), _createBlock(SvgLoader, {
              key: 1,
              id: "update-to-approved-menu-dropdown-arrow",
              name: "arrowDownBlue",
              class: "update-to-approved-menu__arrow"
            }))
      ], 2),
      (isOpen.value)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 0,
            to: "body"
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(UPDATE_TO_APPROVED_MENU_ITEMS), (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option,
                  class: "update-to-approved-menu__option",
                  onClick: ($event: any) => (selectOption(option))
                }, _toDisplayString(_unref(UpdateToApprovedMenuService).getDisplayText(option)), 9, _hoisted_4))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})